<template>
   <div>
        <dropper v-if="isDragged" :index="index" :level="2" class="bottom10"></dropper>
        <div  v-if="$parent.editMode"  class="delete is-pulled-right" @click="remove"></div>
        <div v-if="isDragged && index > 0 && !$parent.editMode" class="top40">&nbsp;</div>
        <div class="bledHeroBlack bleed" :class="{'marginTop0': $parent.editMode }">
         
          <div class="container cmsLandingHeader">
              
                <div class="columns top10" style="margin-bottom: 10px">
                 
                    <div class="column is-two-thirds">
                       <div  class="has-text-white cmsHeaderTit pad10" >
                         <img src="@/assets/img/fourDotsLogo.png" width="34"/> <div ref="tit" class="is-inline-block left10" :contenteditable="$parent.editMode" @focus="setDirty('tit')" @blur="update('tit')" :class="{cmsItemFocused: titFocused}"><b>{{params.title}}</b></div>
                       </div>


                       <!-- TEXT -->
                       <div ref="text" class="has-text-white is-size-5 left-5">
                            <div v-show="!txtFocused || !$parent.editMode">
                            <div class="ql-snow top-10"><div class="ql-editor" style="min-height: 0">
                                <div v-html="localTxt"   @click="setDirty('text')"></div>
                            </div>
                        </div></div>

                        <div v-show="$parent.editMode && txtFocused" class="left10">
                            <vue-editor :id="'editor' + index" v-model="localTxt" :editorToolbar="customToolbar"></vue-editor>
                            <button class="button is-coolGreen" @click="update('text')">APPLY</button>&nbsp;<button class="button" @click="cancel">CANCEL</button>
                        </div>
                       </div>
                    </div>
                
    
                    <div class="column has-text-right cmsHeaderAd" >
                        <ad class="enlarge"></ad>
                    </div>
                  
                </div>
          </div>
        </div>
   </div>
</template>


<script>
import dropper from './sectionDropper.vue'
import colDrop from './colDrop.vue'
import ad from '../Ad.vue'
import { AZEventBus } from '../AZEventBus'
import { VueEditor } from "vue2-editor";

export default{
    props: {params: Object, index: Number, isDragged: Boolean},
    components: {dropper, colDrop, ad, VueEditor},
    data: function(){
        return {
            dirty: '',
            rand1: az.getRandomInt(99999999999),
            imgId: 1,
            images: [],
            remImages: [],
            titFocused: false,
            txtFocused: false,
            localTxt: this.$parent.source[this.index].params.text.split('**eq**').join('='),
            customToolbar: [
                            [{
                    header: [false, 1, 2, 3, 4, 5, 6]
                }],
                ["bold", "italic", "underline", "strike"],
                [{
                        align: ""
                    }, {
                        align: "center"
                    }, {
                        align: "right"
                    }, {
                        align: "justify"
                }],
                [{ list: "ordered" }, { list: "bullet" }],
                ["link","image", "video"],
                [{
                        indent: "-1"
                    }, {
                        indent: "+1"
                    }], // outdent/indent
                    [{
                        color: ['rgb(255,255,255)','rgb(241,194,50)','rgb(255,153,0)', 'rgb(150,150,150)']
                    }, {
                        background: []
                }]
            ]
        }
    },

    mounted: function(){
      
        var self = this;
        // Select the node that will be observed for mutations
        const targetNode = document.getElementById("editor" + this.index);

        // Options for the observer (which mutations to observe)
        const config = { attributes: true, childList: true, subtree: true };

        // Callback function to execute when mutations are observed
        const callback = (mutationList, observer) => {
            for (const mutation of mutationList) {
                if (mutation.type === "childList") {
                    
                    


                    if(mutation.addedNodes[0] && mutation.addedNodes[0].tagName  == 'IMG'){
                        console.log(mutation.addedNodes)
                        if(mutation.addedNodes[0].src.split('m-ii-cms-img').length > 1){
                            setTimeout(() => {
                                console.log(mutation.addedNodes[0].naturalWidth)
                                 mutation.addedNodes[0].setAttribute('width', mutation.addedNodes[0].naturalWidth + 'px')
                                 mutation.addedNodes[0].setAttribute('height', 'auto')
                                 mutation.addedNodes[0].style['max-height'] = ''
                            }, 5)
                            
                          /*   var i = document.createElement("img")
                            i.setAttribute('src', mutation.addedNodes[0].src)
                            mutation.addedNodes[0].appendChild(i) */
                        } else {
                            mutation.addedNodes[0].azId = self.imgId
                            self.images.push({mut: mutation.addedNodes[0], id: self.imgId})
                            self.imgId += 1;
                        }

                      
                    }
                        

                    if(mutation.removedNodes[0] && mutation.removedNodes[0].tagName == 'IMG'){
                        if(mutation.removedNodes[0].azId){
                            //remove from image array
                            self.images = self.images.filter(e => {
                                return e.id != mutation.removedNodes[0].azId
                            })

                        } /* else {
                            //set to be removed from server
                            self.remImages.push({url: self.images.push(mutation.addedNodes[0].src)})
                        } */
                    }
                    

                } else if (mutation.type === "attributes") {
                    //console.log(`The ${mutation.attributeName} attribute was modified.`);
                }
            }
        };

        // Create an observer instance linked to the callback function
        const observer = new MutationObserver(callback);

        // Start observing the target node for configured mutations
        observer.observe(targetNode, config);
              

                
            

        setTimeout(function(){
            self.$parent.adsLoaded = true
        }, 10)

      
    },

    beforeDestroy: function(){

    },

    methods: {
        update: function(t){

            this.localTxt = az.convertATagsToSelf(this.localTxt)

          if(t == 'tit'){
            this.titFocused = false
            if(this.$refs[t].innerText != this.dirty){
                this.$parent.source[this.index].params.title = this.$refs[t].innerText
                AZEventBus.$emit('pageChanged', null)
            } 
            

          } else {
            var self = this;
          this.txtFocused = false

          var mut = null
          if(this.images.length){

            var count = 0
            
                function w(d){

                    var a = self.images.find(n => {
                        return n.mut.azId == d.id
                    })

                    a.mut.src = d.img

                    count += 1
                    if((self.localTxt != self.dirty) && count == self.images.length){
                        
                        setTimeout(() => {
                            self.$parent.source[self.index].params.text = self.localTxt.split('=').join('**eq**')
                        }, 5)
                    
                        AZEventBus.$emit('pageChanged', null)
                    }
                }

                function n(){
                    
                }

            
                this.images.forEach((e) => {
                    self.$root.app.apiClient.post('subs/data/cmsimg', {imgFile: e.mut.src, id: e.mut.azId}, w, n)
                })
                
            } else {
                if(self.localTxt != this.dirty){
                    this.$parent.source[this.index].params.text = this.localTxt.split('=').join('**eq**')
                    AZEventBus.$emit('pageChanged', null)
                }
            }
          }
        },

        cancel: function(){
            this.txtFocused = false
            this.localTxt = this.$parent.source[this.index].params.text.split('**eq**').join('=')
        },

        remove: function(){
            this.$parent.removeSection(this.index)
        },

        setDirty: function(t){
            if(t == 'tit'){
                this.titFocused = true
                this.dirty = this.$refs[t].innerText
            } else {
                this.txtFocused = true
                this.dirty = this.localTxt
            }
        }
    }
}


</script>